import { render, staticRenderFns } from "./VoucherItemHeader.vue?vue&type=template&id=8dc09674&scoped=true&"
import script from "./VoucherItemHeader.vue?vue&type=script&lang=js&"
export * from "./VoucherItemHeader.vue?vue&type=script&lang=js&"
import style0 from "./VoucherItemHeader.vue?vue&type=style&index=0&id=8dc09674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc09674",
  null
  
)

export default component.exports